import { useState, useEffect } from 'react';
import Modal from 'react-modal';
import api from '../../service/api';
import '../../css/Anamnese.css';
import '../../css/Antropometria.css';
import IconDuvida from '../../images/icon-duvida-2.png';
import tabelaImc0 from '../../images/tabelaImc0.png';
import tabelaImc1 from '../../images/tabelaImc1.png';
import tabelaImc2 from '../../images/tabelaImc2.png';
import tabelaImc3 from '../../images/tabelaImc3.png';
import tabelaPant0 from '../../images/tabelaPant0.png';
import tabelaPant1 from '../../images/tabelaPant1.png';
import tabelaPant2 from '../../images/tabelaPant2.png';
import tabelaPant3 from '../../images/tabelaPant3.png';
import imgClean from '../../images/desenho-corpo-clean.jpg';
import imgOmbro from '../../images/desenho-corpo-ombro.jpg';
import imgTorax from '../../images/desenho-corpo-torax.jpg';
import { formatarNumero } from '../../utils/formato';

function Antropometria({ setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {
    const [etapa, setEtapa] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const totalEtapas = 3;
    const porcentagemConclusao = (etapa / totalEtapas) * 100;

    const [peso, setPeso] = useState('');
    const [altura, setAltura] = useState('');
    const [panturrilha, setPanturrilha] = useState('0');
    const [imc, setImc] = useState(0);

    const [ombro, setOmbro] = useState('');
    const [toraxNormal, setToraxNormal] = useState('');
    const [toraxInspirado, setToraxInspirado] = useState('');
    const [abdomen, setAbdomen] = useState('');
    const [cintura, setCintura] = useState('');
    const [quadril, setQuadril] = useState('');
    const [coxaD, setCoxaD] = useState('');
    const [coxaE, setCoxaE] = useState('');
    const [pernaD, setPernaD] = useState('');
    const [pernaE, setPernaE] = useState('');
    const [bracoDrelaxado, setBracoDrelaxado] = useState('');
    const [bracoErelaxado, setBracoErelaxado] = useState('');
    const [bracoDcontraido, setBracoDcontraido] = useState('');
    const [bracoEcontraido, setBracoEcontraido] = useState('');
    const [antebracoD, setAntebracoD] = useState('');
    const [antebracoE, setAntebracoE] = useState('');
    const [punhoD, setPunhoD] = useState('');
    const [punhoE, setPunhoE] = useState('');

    useEffect(() => {
        const d = evaluationData?.antropometriaIdosos;
        if (d) {
            if (d.peso) setPeso(d.peso);
            if (d.altura) setAltura(d.altura);
            if (d.panturrilha) setPanturrilha(d.panturrilha);
            if (d.imc) setImc(d.imc);
            if (d.ombro) setOmbro(d.ombro);
            if (d.toraxNormal) setToraxNormal(d.toraxNormal);
            if (d.toraxInspirado) setToraxInspirado(d.toraxInspirado);
            if (d.abdomen) setAbdomen(d.abdomen);
            if (d.cintura) setCintura(d.cintura);
            if (d.quadril) setQuadril(d.quadril);
            if (d.coxaD) setCoxaD(d.coxaD);
            if (d.coxaE) setCoxaE(d.coxaE);
            if (d.pernaD) setPernaD(d.pernaD);
            if (d.pernaE) setPernaE(d.pernaE);
            if (d.bracoDrelaxado) setBracoDrelaxado(d.bracoDrelaxado);
            if (d.bracoErelaxado) setBracoErelaxado(d.bracoErelaxado);
            if (d.bracoDcontraido) setBracoDcontraido(d.bracoDcontraido);
            if (d.bracoEcontraido) setBracoEcontraido(d.bracoEcontraido);
            if (d.antebracoD) setAntebracoD(d.antebracoD);
            if (d.antebracoE) setAntebracoE(d.antebracoE);
            if (d.punhoD) setPunhoD(d.punhoD);
            if (d.punhoE) setPunhoE(d.punhoE);
        }
    }, [evaluationData]);

    const avancarEtapa = () => {
        setEtapa(etapa + 1);
    };

    const retrocederEtapa = () => {
        if (etapa > 1) {
            setEtapa(etapa - 1);
        }
    };

    // Para calcular o peso automaticamente, mas esta dando erro
    let timeout;
    const handlePesoChange = (e) => {
        setPeso(e.target.value);
        clearTimeout(timeout);
        timeout = setTimeout(calcularIMC, 500);
    };

    const handleAlturaChange = (e) => {
        setAltura(e.target.value);
        clearTimeout(timeout);
        timeout = setTimeout(calcularIMC, 500);
    };

    const calcularIMC = () => {
        const pesoFloat = parseFloat(peso);
        const alturaEmMetros = parseFloat(altura) / 100;
        const imcCalculado = pesoFloat / (alturaEmMetros * alturaEmMetros);
        setImc(formatarNumero(imcCalculado, 2));
    };

    const [showInfo, setShowInfo] = useState(false);
    const [showImc, setShowImc] = useState(false);
    const [showCirc, setShowCirc] = useState(false);

    const [imagemCorpo, setImagemCorpo] = useState(imgClean);

    let tabelaImc;
    if (imc == 0) {
        tabelaImc = tabelaImc0
    } else if (imc < 22) {
        tabelaImc = tabelaImc1;
    } else if (imc >= 22 && imc <= 27) {
        tabelaImc = tabelaImc2;
    } else {
        tabelaImc = tabelaImc3;
    }

    let tabelaPant = tabelaPant0;
    if (panturrilha == 0) {
        tabelaPant = tabelaPant0
    } else if (panturrilha > 35) {
        tabelaPant = tabelaPant1;
    } else if (panturrilha >= 31 && panturrilha <= 35) {
        tabelaPant = tabelaPant2;
    } else {
        tabelaPant = tabelaPant3;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            antropometriaIdosos: {
                peso, altura, panturrilha, imc,
                ombro, toraxNormal, toraxInspirado, abdomen, cintura, quadril,
                coxaD, coxaE, pernaD, pernaE,
                bracoDrelaxado, bracoErelaxado, bracoDcontraido, bracoEcontraido,
                antebracoD, antebracoE, punhoD, punhoE
            },
            evaluationId
        };

        try {
            const response = await api.post(`/api/student/${aluno.id}/evaluation/antropometria-idosos`, payload, { withCredentials: true });
            if (response.status === 200) {
                if (response.data.evaluationId && setEvaluationId) {
                    if (!evaluationId) {
                        if (!aluno.avaliacoesRealizadas) aluno.avaliacoesRealizadas = [];
                        aluno.avaliacoesRealizadas.push({
                            id: response.data.evaluationId,
                            data: new Date().toISOString()
                        });
                    }
                    setEvaluationId(response.data.evaluationId);
                }
                if (updateEvaluationData) {
                    updateEvaluationData({ antropometriaIdosos: payload.antropometriaIdosos });
                }
                setIsModalOpen(true);
            }
        } catch (error) {
            console.error('Erro ao salvar Antropometria Idosos:', error);
        }
    };

    return (

        <div className='forms-padrao-main'>
            <div className="forms-padrao-header">
                <text>Antropometria</text>
                <img className="img-duvida-l" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)} src={IconDuvida} alt="Duvida" />
                {showInfo && (
                    <div className="info-box">
                        <p className="info-box-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ac lobortis lorem. Aenean ut scelerisque mauris. Donec at augue lorem.
                            Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Sed mollis varius blandit. Nullam id efficitur libero, eu pellentesque eros.
                            Etiam vestibulum sapien eu faucibus rhoncus.
                        </p>
                    </div>
                )}
            </div>
            <div className="linha-red-antro"></div>

            <div className="forms-padrao-div-bottom">
                <form onSubmit={handleSubmit}>
                    {etapa === 1 && (
                        <div className="colunas-padrao">
                            <div className="colunas-padrao-50">
                                <div className="perguntas-form-padrao">
                                    <text className='titulo-antropometria'>Cálculo do índice de massa corporal (IMC)</text>
                                    <img className="img-imc-circ" onMouseEnter={() => setShowImc(true)} onMouseLeave={() => setShowImc(false)} src={IconDuvida} alt="Duvida" />
                                </div>
                                {showImc && (
                                    <div className="box-imc-circ">
                                        <p>Para a verificação do Índice de Massa Corporal (IMC), afere-se a massa
                                            corporal e a estatura que são medidas importantes para a avaliação do
                                            perfil nutricional e antropométrico dos idosos.(WHO, 2018)<br></br>
                                            Utiliza-se as medidas da massa corporal e da estatura, para calcular o IMC
                                            dos participantes obtido pela relação entre as medidas expressas na
                                            fórmula a seguir, sendo a massa corporal aferido em Quilogramas (kg) e a
                                            estatura medida em metros (m): IMC = Massa corporal / estatura em m2
                                            Para classificação do estado nutricional do idoso a partir do IMC, utilizou-se
                                            os pontos de corte de (LIPSCHITZ, 1994)
                                        </p>
                                    </div>
                                )}
                                <div className="respostas-form-padrao pad-top-10">
                                    <text class="perguntas-desc texto-bold">Peso (Kg):</text>
                                    <input className="entrada-texto-pequena margin-l-010" type="text" name="peso" placeholder={peso} value={peso} onChange={e => setPeso(e.target.value)} />
                                    <text class="perguntas-desc texto-bold pad-left-20">Altura (Cm):</text>
                                    <input className="entrada-texto-pequena margin-l-010" type="text" name="altura" placeholder={altura} value={altura} onChange={e => setAltura(e.target.value)} />
                                    <button className="btt-imc margin-left-20" type="button" onClick={calcularIMC}>Calcular IMC</button>
                                </div>

                                <div className="respostas-form-padrao-coluna">
                                    <text class="resultado-imc-circ">IMC: {imc} Kg/m²</text>
                                    <img className="tabela-imc-circ" src={tabelaImc} alt="tabela imc" />
                                </div>
                            </div>

                            <div className="colunas-padrao-50">
                                <div className="perguntas-form-padrao">
                                    <text className='titulo-antropometria'>Medida da circunferência da perna esquerda</text>
                                    <img className="img-imc-circ" onMouseEnter={() => setShowCirc(true)} onMouseLeave={() => setShowCirc(false)} src={IconDuvida} alt="Duvida" />
                                </div>
                                {showCirc && (
                                    <div className="box-imc-circ">
                                        <p>A circunferência da panturrilha é o parâmetro que fornece a medida mais
                                            sensível da massa muscular nos idosos. Para a correta medição da
                                            circunferência da panturrilha, a fita métrica inextensível deve ser
                                            posicionada horizontalmente na área de maior diâmetro da panturrilha, no
                                            espaço entre o tornozelo e o joelho.<br></br>
                                            O idoso deve estar sentado, relaxado
                                            ou em pé com o peso distribuído equitativamente entre ambos os pés. Para
                                            a classificação do estado nutricional do idoso a partir da circunferência da
                                            panturrilha, são utilizados os pontos de corte apresentados no quadro a
                                            classificação do estado nutricional do idoso a partir da circunferência da
                                            panturrilha, são utilizados os pontos de corte apresentados no quadro.
                                        </p>
                                    </div>
                                )}
                                <div className="respostas-form-padrao pad-top-10">
                                    <text class="perguntas-desc texto-bold">Medida da panturrilha (Cm):</text>
                                    <input className="entrada-texto-pequena margin-l-010" type="text" name="panturrilha" placeholder={panturrilha} value={panturrilha} onChange={e => setPanturrilha(e.target.value)} />
                                </div>
                                <div className="respostas-form-padrao-coluna">
                                    <text class="resultado-imc-circ">Panturrilha: {panturrilha} cm</text>
                                    <img className="tabela-imc-circ" src={tabelaPant} alt="tabela imc" />
                                </div>
                            </div>
                        </div>

                    )}


                    {etapa === 2 && (
                        <div className="colunas-padrao">
                            <div className="colunas-padrao-700">
                                <div className="perguntas-form-padrao">
                                    <text className='titulo-antropometria'>Perímetros corporais</text>
                                </div>
                                <div className="respostas-form-padrao-coluna">
                                    <text class="perguntas-desc">Observação: Todas as medidas devem ser feitas em centímetros.
                                    </text>
                                </div>


                                <div class="colunas-perimetro">
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Ombro:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="ombro" placeholder={ombro} value={ombro} onClick={() => setImagemCorpo(imgOmbro)} onChange={e => setOmbro(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Tórax normal:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="toraxNormal" placeholder={toraxNormal} value={toraxNormal} onClick={() => setImagemCorpo(imgTorax)} onChange={e => setToraxNormal(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Tórax inspirado:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="toraxInspirado" placeholder={toraxInspirado} value={toraxInspirado} onChange={e => setToraxInspirado(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">

                                    </div>
                                </div>

                                <div class="colunas-perimetro">
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Abdômen:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="abdomen" placeholder={abdomen} value={abdomen} onChange={e => setAbdomen(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Cintura:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="cintura" placeholder={cintura} value={cintura} onChange={e => setCintura(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Quadril:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="quadril" placeholder={quadril} value={quadril} onChange={e => setQuadril(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">

                                    </div>
                                </div>

                                <div class="colunas-perimetro">
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Coxa D:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="coxaD" placeholder={coxaD} value={coxaD} onChange={e => setCoxaD(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Coxa E:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="coxaE" placeholder={coxaE} value={coxaE} onChange={e => setCoxaE(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Perna D:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="pernaD" placeholder={pernaD} value={pernaD} onChange={e => setPernaD(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Perna E:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="pernaE" placeholder={pernaE} value={pernaE} onChange={e => setPernaE(e.target.value)} />
                                        </div>
                                    </div>
                                </div>

                                <div class="colunas-perimetro">
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Braço D relaxado:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="bracoDrelaxado" placeholder={bracoDrelaxado} value={bracoDrelaxado} onChange={e => setBracoDrelaxado(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Braço E relaxado:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="bracoErelaxado" placeholder={bracoErelaxado} value={bracoErelaxado} onChange={e => setBracoErelaxado(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Antebraço D:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="antebracoD" placeholder={antebracoD} value={antebracoD} onChange={e => setAntebracoD(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Antebraço E:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="antebracoE" placeholder={antebracoE} value={antebracoE} onChange={e => setAntebracoE(e.target.value)} />
                                        </div>
                                    </div>
                                </div>

                                <div class="colunas-perimetro">
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Braço D contraido:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="bracoDcontraido" placeholder={bracoDcontraido} value={bracoDcontraido} onChange={e => setBracoDcontraido(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Braço E contraido:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="bracoEcontraido" placeholder={bracoEcontraido} value={bracoEcontraido} onChange={e => setBracoEcontraido(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Punho D:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="punhoD" placeholder={punhoD} value={punhoD} onChange={e => setPunhoD(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="coluna-perimetro-185">
                                        <div className='entrada-perimetros'>
                                            <text class="perg-perimetros">Punho E:</text>
                                            <input className="entrada-texto-perimetros" type="text" name="punhoE" placeholder={punhoE} value={punhoE} onChange={e => setPunhoE(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='div-imagem-corpo'>
                                <img className="img-corpo" src={imagemCorpo} alt="corpo-humano" />
                            </div>
                        </div>
                    )}

                    <div className="footer-padrao">
                        <div>
                            {etapa > 0 && (
                                <button className="botoes-form-padrao" type="button" onClick={retrocederEtapa}>
                                    Voltar
                                </button>
                            )}

                            {etapa < 3 ? (
                                <button className="botoes-form-padrao" type="button" onClick={avancarEtapa}>
                                    Avançar
                                </button>
                            ) : (
                                <button className="botoes-form-padrao" type="submit">Salvar</button>
                            )}
                        </div>
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
                        </div>
                    </div>
                </form>
            </div>

            <Modal isOpen={isModalOpen} onRequestClose={() => setIsModalOpen(false)} contentLabel="Confirmacao" className="modal-next" overlayClassName="popup-overlay">
                <p className="popupNext-h1">Antropometria finalizada!</p>
                <p className="popupNext-h2">Deseja ir para a Composição Corporal?</p>
                <div className="sub-pagination-buttons">
                    <button className="next-prev-button" type="button" onClick={() => setActiveTab("Composicao Corporal")}>Sim</button>
                    <button className="next-prev-button" type="button" onClick={() => setIsModalOpen(false)}>Não</button>
                </div>
            </Modal>
        </div>

    );
};

export default Antropometria;
